// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__we7qw","requiredAsterisk":"Info_requiredAsterisk__s_8so"};